import { Controller } from "@hotwired/stimulus"
import { SyncStatus } from "./sync_status"

export default class SyncIndicatorController extends Controller {
  static targets = ["message"]
  static values = {
    syncingText: String,
    pendingText: String,
    deferredText: String,
  }

  declare readonly messageTarget: HTMLElement
  declare readonly syncingTextValue: string
  declare readonly pendingTextValue: string
  declare readonly deferredTextValue: string

  update(event: CustomEvent): void {
    const status = event.detail.syncStatus as string

    const textMap: Record<string, string> = {
      [SyncStatus.Syncing]: this.syncingTextValue,
      [SyncStatus.Pending]: this.pendingTextValue,
      [SyncStatus.Deferred]: this.deferredTextValue,
    }

    const show = status && status !== SyncStatus.None && !!textMap[status]
    this.element.classList.toggle("hidden", !show)
    if (show) {
      this.messageTarget.textContent = textMap[status]
    }
  }
}
